module.exports = __webpack_public_path__ + "img/1594892393.858e7b18.jpg";